var $ = jQuery.noConflict();
//POPUP WIDEO
$(window).load(function () {
    $(document).on('open.zf.reveal', '[data-reveal]', function (ev) {
        var modal = $(this);
        if (modal.data('src') && modal.data('src') != 'undefined' && modal.data('src') != '') {
            var iframe = $('<iframe  frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
            iframe.attr('src', modal.data('src'));
            if (modal.find('.flex-video').length > 0) {
                modal.find('.flex-video').html(iframe);
            } else {
                modal.find('.video-container').html(iframe);
            }

        }
    });

    $(document).on('closed.zf.reveal', '[data-reveal]', function () {
        var modal = $(this);
        $(modal).find('iframe').remove();
    });
});